import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import { IconButton } from '@bibliocommons/base-buttons';
import { Close } from '@bibliocommons/base-icons';

import './Pill.scss';

export default function Pill({ className, children, icon, handleDismiss }) {
  const renderDismissButton = () =>
    handleDismiss && (
      <IconButton dataKey="pill-dismiss" handleClick={handleDismiss}>
        <ScreenReaderMessage>
          <FormattedMessage id="remove_pill" values={{ name: children }} />
        </ScreenReaderMessage>
        <Close />
      </IconButton>
    );

  const classNames = cn('cp-pill', className, { 'pill--dismissible': handleDismiss });

  return (
    <span className={classNames}>
      {icon}
      {children}
      {renderDismissButton()}
    </span>
  );
}

Pill.propTypes = {
  className: PropTypes.string,
  children: childrenShape.isRequired,
  icon: PropTypes.node,
  handleDismiss: PropTypes.func
};
